import { 
  TEXT_LAYOUT_SCHEMA, 
  TITLE_LAYOUT_SCHEMA, 
  SUBTITLE_LAYOUT_SCHEMA, 
  OBSERVATION_LAYOUT_SCHEMA, 
  BUTTON_LAYOUT_SCHEMA, 
  BG_LAYOUT_SCHEMA
} from './layout'

const TEXT_CONTENT_SCHEMA = (text = '', alignment = '') => ({
  content: text,
  alignment: alignment
})

const BUTTON_CONTENT_SCHEMA = () => ({
  action: '',
  caption: 'Botão',
  show: false
})

const BG_CONTENT_SCHEMA = (height = '') => ({
  height: height
})

export const TITLE_SCHEMA = (title = '', alignment = '') => TITLE_LAYOUT_SCHEMA(TEXT_CONTENT_SCHEMA(title, alignment))

export const SUBTITLE_SCHEMA = (subtitle = '', alignment = '') => SUBTITLE_LAYOUT_SCHEMA(TEXT_CONTENT_SCHEMA(subtitle, alignment))

export const TEXT_SCHEMA = (text = '', alignment = '') => TEXT_LAYOUT_SCHEMA(TEXT_CONTENT_SCHEMA(text, alignment))

export const OBSERVATION_SCHEMA = (obs = '', alignment = '') => OBSERVATION_LAYOUT_SCHEMA(TEXT_CONTENT_SCHEMA(obs, alignment))

export const BUTTON_SCHEMA = () => BUTTON_LAYOUT_SCHEMA(BUTTON_CONTENT_SCHEMA())

export const BG_SCHEMA = (height = '') => BG_LAYOUT_SCHEMA(BG_CONTENT_SCHEMA(height))

// Utils

export const CREATE_BUTTON = () => BUTTON_SCHEMA()
